import styled from 'styled-components';
import { cells, span } from '../../../styling/utils/grid';
import CheckoutSection from '../utils/Checkout.Section';

export const StyledPrivateCustomerWrapper = styled(CheckoutSection)`
  .section-content {
    display: grid;
    gap: 2.4rem;
    ${cells(2)}
  }
  .checkout__input-oneCol {
    ${span(1)}
  }
  .checkout__input-fullCol {
    ${span(2)}
  }

  .checkout__checkbox {
    display: flex;
    flex: 1;
    margin-top: 2.4rem;
    :not(:first-child) {
      margin-bottom: 2.4rem;
    }
  }
`;
